import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { ConsultaPconRequest, Types } from './types';

// ACTIONS
import { consultaPconSuccess, consultaPconFailure } from './actions';

function* consultaPconRequest(request: ReducerAction) {
	const { payload }: { payload: ConsultaPconRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CNH,
		`eportal/${CHANNEL}/pesquisa/pcon`,
		payload,
	);

	if (response.status === 200) {
		yield put(consultaPconSuccess(response));
	} else {
		yield put(consultaPconFailure(response));
	}
}

export default all([
	takeLatest(Types.CONSULTA_PCON_REQUEST, consultaPconRequest),
]);
